"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = GameplayList;
var jsx_runtime_1 = require("react/jsx-runtime");
var list_style = __importStar(require("./GameplayList.module.scss"));
var icons_1 = require("@assets/icons");
function GameplayList(_a) {
    var title = _a.title, item = _a.item, renderItem = _a.renderItem, deleteItem = _a.deleteItem;
    if (item.length === 0) {
        return ((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)("h3", { children: title }) }));
    }
    return ((0, jsx_runtime_1.jsxs)("div", { className: list_style.gameplay_list, children: [(0, jsx_runtime_1.jsx)("h3", { children: title }), (0, jsx_runtime_1.jsx)("ul", { children: item.map(function (item, id) { return ((0, jsx_runtime_1.jsxs)("li", { children: [" ", (0, jsx_runtime_1.jsx)("span", { children: renderItem(item) }), (0, jsx_runtime_1.jsx)("button", { onClick: function () { return deleteItem(item); }, type: "button", children: icons_1.icons.delete })] }, id)); }) })] }));
}
